import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "resource-panel"
};
var _hoisted_2 = {
  class: "main"
};
var _hoisted_3 = {
  key: 0,
  class: "resource-list"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "cover"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "title"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "preview-header"
};
var _hoisted_10 = {
  class: "header-right"
};
var _hoisted_11 = {
  key: 0,
  class: "preview-content"
};
var _hoisted_12 = ["src"];
import SideBar from './common/SideBar';
import Empty from './common/Empty';
import Preview from './common/Preview';
import UploadFile from './common/UploadFile';
import ChoiseCourse from './common/ChoiseCourse';

/* 工具 */
import { ref, reactive, computed, inject, onMounted } from 'vue';
import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next';
import { operationRecord } from './common/common';
import { LEFT_BAR_MAP } from '../const';
import { getStore } from '@/util/store';
import { debounce } from '@/util/index';
import { getEnvName, getHostName } from '@/util/env';
import { fileClass, imgCoverMap } from '@/utils/index';

/* api */
import { getResourceList, addResource, deleteResource, courseCopy } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'Resource',
  setup: function setup(__props) {
    /* 组件 */
    var discussId = inject('discussId');
    var discussInfo = inject('discussInfo');
    var form = ref();
    var state = reactive({
      addResourceShow: false,
      rules: {
        type: [{
          required: true
        }],
        file: [{
          required: true
        }]
      },
      formData: {
        type: 0,
        file: [],
        course: []
      },
      resourceList: [],
      previewShow: false,
      // 预览弹窗
      previewInfo: {} // 预览信息
    });

    /* 计算属性 */
    // 当前是否为创建者
    var isCreator = computed(function () {
      var _discussInfo$value;
      var userInfo = getStore({
        name: 'userInfo'
      });
      return userInfo.id === ((_discussInfo$value = discussInfo.value) === null || _discussInfo$value === void 0 ? void 0 : _discussInfo$value.creatorId);
    });
    var checkCourseId = computed(function () {
      return state.resourceList.filter(function (e) {
        return e.type === 1;
      }).map(function (e) {
        return e.courseIdOrUrl;
      });
    });

    /* 事件 */
    // 侧边栏点击
    var sideBarChange = function sideBarChange(item) {
      if (item.click === 'resourceAdd') {
        state.addResourceShow = true;
      }
    };

    // 文件封面图
    var fileCover = function fileCover(item) {
      var res = null;
      if (item.type === 0) {
        var fileType = fileClass(item.courseIdOrUrl);
        res = imgCoverMap[fileType];
      } else {
        res = require('@/assets/icon/course.png');
      }
      return res;
    };

    // 关闭弹窗
    var onClose = function onClose() {
      form.value.reset();
      state.formData.file = [];
      state.formData.course = [];
    };

    // 弹窗确认
    var onConfirm = debounce(function () {
      form.value.submit();
    });

    // 切换类型
    var typeChange = function typeChange(type) {
      if (type === 0) {
        delete state.rules.course;
        state.rules.file = [{
          required: true
        }];
        state.formData.file = [];
      } else {
        delete state.rules.file;
        state.rules.course = [{
          required: true
        }];
        state.formData.course = [];
      }
    };

    // 提交
    var onSubmit = function onSubmit() {
      form.value.validate().then(function (result) {
        if (result && Object.keys(result).length) {
          var _Object$values$;
          var firstError = (_Object$values$ = Object.values(result)[0]) === null || _Object$values$ === void 0 || (_Object$values$ = _Object$values$[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.message;
          MessagePlugin.warning(firstError);
        }
        if (result === true) {
          var data = {
            discussId: discussId.value,
            type: state.formData.type,
            resources: []
          };
          if (state.formData.type === 0) {
            var _state$formData$file;
            data.resources = (_state$formData$file = state.formData.file) === null || _state$formData$file === void 0 ? void 0 : _state$formData$file.map(function (e) {
              return {
                title: e.name,
                courseIdOrUrl: e.url,
                version: 2,
                source: 2
              };
            });
          } else {
            var _state$formData$cours;
            data.resources = (_state$formData$cours = state.formData.course) === null || _state$formData$cours === void 0 ? void 0 : _state$formData$cours.map(function (e) {
              return {
                title: e.title,
                courseIdOrUrl: e.id,
                version: e.version,
                source: e.source
              };
            });
          }
          addResource(data).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('添加成功！');
              getResource();
              state.addResourceShow = false;
              state.formData.file = [];
              state.formData.course = [];
            }
          });
        }
      });
    };

    // 列表查询
    var getResource = function getResource() {
      getResourceList(discussId.value).then(function (res) {
        if (res.data.code === 0) {
          state.resourceList = res.data.data || [];
        }
      });
    };

    // 删除资料
    var delResource = function delResource(id) {
      var dialog = DialogPlugin({
        header: '删除资料',
        body: '是否删除该资料',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function onConfirm() {
          deleteResource(discussId.value, id).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('删除成功！');
              dialog.destroy();
              getResource();
            }
          });
        }
      });
    };

    // 关闭预览
    var previewClose = function previewClose() {
      state.previewInfo = {};
      state.previewShow = false;
    };

    // 跳转详情
    var toDetail = function toDetail(item) {
      state.previewInfo = {
        type: item.type,
        title: item.title
      };
      if (item.type === 0) {
        // 资源预览
        state.previewInfo.url = item.courseIdOrUrl;
      } else if (item.type === 1) {
        // 学程预览
        var url = '';
        var env_name = getEnvName();
        var hostName = getHostName();
        var token = getStore({
          name: 'access_token'
        });
        if (Number(item.version) === 2) {
          // 新
          url = "//".concat(env_name || 'edu-', "course.").concat(hostName, "/preview?courseId=").concat(item.courseIdOrUrl, "&token=").concat(token);
        } else {
          // 旧
          url = env_name ? "//".concat(env_name, "web.").concat(hostName, "/courseDetail?id=").concat(item.courseIdOrUrl, "&token=").concat(token) : "//web.zhixuehuijiao.cn/courseDetail?id=".concat(item.courseIdOrUrl, "&token=").concat(token);
        }
        state.previewInfo.url = url;
        state.previewInfo.courseId = item.courseIdOrUrl;
      }
      state.previewShow = true;
      operationRecord(discussId.value, '查看资料');
    };

    // 保存学程
    var courseSave = function courseSave() {
      courseCopy(discussId.value, state.previewInfo.courseId).then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('已保存至“创作中心”的“创作”中！');
        }
      });
    };

    // 下载文件
    var downloadFile = function downloadFile() {
      var url = state.previewInfo.url;
      var name = state.previewInfo.title;
      return new Promise(function (resolve) {
        fetch(url).then(function (response) {
          return response.blob();
        }).then(function (blob) {
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = name;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          MessagePlugin.success('下载成功！');
          resolve(true);
        }).catch(function (error) {
          resolve(false);
        });
      });
    };

    /* 钩子 */
    onMounted(function () {
      getResource();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_radio = _resolveComponent("t-radio");
      var _component_t_radio_group = _resolveComponent("t-radio-group");
      var _component_t_form_item = _resolveComponent("t-form-item");
      var _component_t_form = _resolveComponent("t-form");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(SideBar), {
        barList: _unref(LEFT_BAR_MAP)['resource'],
        onTabChange: sideBarChange
      }, null, 8, ["barList"]), _createElementVNode("div", _hoisted_2, [state.resourceList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.resourceList, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "resource-item",
          onClick: function onClick($event) {
            return toDetail(item);
          }
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: fileCover(item),
          alt: ""
        }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.title), 1)]), isCreator.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "delete",
          onClick: _withModifiers(function ($event) {
            return delResource(item.id);
          }, ["stop"])
        }, [_createVNode(_component_svg_icon, {
          name: "dialog-close-white",
          size: "10"
        })], 8, _hoisted_8)) : _createCommentVNode("", true)], 8, _hoisted_4);
      }), 128))])) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        name: "resource"
      })), _createVNode(_component_t_dialog, {
        visible: state.addResourceShow,
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return state.addResourceShow = $event;
        }),
        header: "添加资料",
        width: "480px",
        placement: "center",
        onClose: onClose,
        onConfirm: _unref(onConfirm)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_form, {
            ref_key: "form",
            ref: form,
            data: state.formData,
            rules: state.rules,
            showErrorMessage: false,
            "label-align": "top",
            resetType: "initial",
            onSubmit: onSubmit
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_form_item, {
                label: "资料类型",
                name: "type"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_t_radio_group, {
                    modelValue: state.formData.type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return state.formData.type = $event;
                    }),
                    "default-value": 0,
                    onChange: typeChange
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_t_radio, {
                        value: 0
                      }, {
                        default: _withCtx(function () {
                          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("文件", -1)]));
                        }),
                        _: 1
                      }), _createVNode(_component_t_radio, {
                        value: 1
                      }, {
                        default: _withCtx(function () {
                          return _toConsumableArray(_cache[6] || (_cache[6] = [_createTextVNode("学程", -1)]));
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }), state.formData.type === 0 ? (_openBlock(), _createBlock(_component_t_form_item, {
                key: 0,
                label: "上传文件",
                name: "file"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(UploadFile), {
                    list: state.formData.file,
                    "onUpdate:list": _cache[1] || (_cache[1] = function ($event) {
                      return state.formData.file = $event;
                    }),
                    multiple: ""
                  }, null, 8, ["list"])];
                }),
                _: 1
              })) : _createCommentVNode("", true), state.formData.type === 1 ? (_openBlock(), _createBlock(_component_t_form_item, {
                key: 1,
                label: "关联学程",
                name: "course"
              }, {
                default: _withCtx(function () {
                  return [state.addResourceShow ? (_openBlock(), _createBlock(_unref(ChoiseCourse), {
                    key: 0,
                    checked: state.formData.course,
                    "onUpdate:checked": _cache[2] || (_cache[2] = function ($event) {
                      return state.formData.course = $event;
                    }),
                    disableId: checkCourseId.value
                  }, null, 8, ["checked", "disableId"])) : _createCommentVNode("", true)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["data", "rules"])];
        }),
        _: 1
      }, 8, ["visible", "onConfirm"]), _createVNode(_component_t_dialog, {
        visible: state.previewShow,
        "onUpdate:visible": _cache[4] || (_cache[4] = function ($event) {
          return state.previewShow = $event;
        }),
        class: "preview-dialog",
        width: "85vw",
        placement: "center",
        closeBtn: false,
        footer: false
      }, {
        header: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(state.previewInfo.title), 1), _createElementVNode("div", _hoisted_10, [state.previewInfo.type === 1 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn",
            onClick: courseSave
          }, [_createVNode(_component_svg_icon, {
            name: "resource-save"
          }), _cache[7] || (_cache[7] = _createElementVNode("span", null, "保存", -1))])) : _createCommentVNode("", true), state.previewInfo.type === 0 ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn",
            onClick: downloadFile
          }, [_createVNode(_component_svg_icon, {
            name: "resource-download"
          }), _cache[8] || (_cache[8] = _createElementVNode("span", null, "下载", -1))])) : _createCommentVNode("", true), _createVNode(_component_svg_icon, {
            class: "close",
            name: "dialog-close-white",
            onClick: previewClose
          })])])];
        }),
        default: _withCtx(function () {
          return [state.previewShow ? (_openBlock(), _createElementBlock("div", _hoisted_11, [state.previewInfo.type === 0 ? (_openBlock(), _createBlock(_unref(Preview), {
            key: 0,
            path: state.previewInfo.url
          }, null, 8, ["path"])) : _createCommentVNode("", true), state.previewInfo.type === 1 ? (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            src: state.previewInfo.url,
            frameborder: "0"
          }, null, 8, _hoisted_12)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible"])])]);
    };
  }
};